import React from "react"

export function Projects(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.03125 1.3125H8.96875C9.08906 1.3125 9.1875 1.41094 9.1875 1.53125V2.625H4.8125V1.53125C4.8125 1.41094 4.91094 1.3125 5.03125 1.3125ZM3.5 1.53125V2.625H1.75C0.784766 2.625 0 3.40977 0 4.375V7H5.25H8.75H14V4.375C14 3.40977 13.2152 2.625 12.25 2.625H10.5V1.53125C10.5 0.686328 9.81367 0 8.96875 0H5.03125C4.18633 0 3.5 0.686328 3.5 1.53125ZM14 7.875H8.75V8.75C8.75 9.23398 8.35898 9.625 7.875 9.625H6.125C5.64102 9.625 5.25 9.23398 5.25 8.75V7.875H0V11.375C0 12.3402 0.784766 13.125 1.75 13.125H12.25C13.2152 13.125 14 12.3402 14 11.375V7.875Z"
        fill="currentColor"
      />
    </svg>
  )
}
